import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

const MODERN_COLORS = {
  botBubble: '#F3F4F6',
  dot: '#9CA3AF',
};

export const SimpleTypingIndicator: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2 }}
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: MODERN_COLORS.botBubble,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        {[0, 1, 2].map((index) => (
          <motion.div
            key={index}
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              delay: index * 0.2,
              ease: 'easeInOut',
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: MODERN_COLORS.dot,
              }}
            />
          </motion.div>
        ))}
      </Box>
    </motion.div>
  );
};